import { ArrowUp, ArrowUpRight } from 'lucide-react';
import { MotionConfig } from 'framer-motion';
import { Toaster } from './components/ui/sonner';
import { Brand } from './components/Brand';
import { Hero } from './components/Hero';
import { QuickContacts, About, BrandMarquee } from './components/ContactSections';
import { ContactForm } from './components/ContactForm';
import { SmoothScroll } from './components/Motion';
import './App.css';
import './readability.css';
import './branding.css';

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <SmoothScroll />
      <a className="skip-link" href="#contatto" data-testid="skip-to-contact-link">Vai al modulo di contatto</a>
      <div id="inizio" />
      <header className="site-header page-width" data-testid="site-header">
        <Brand />
        <nav className="header-nav" aria-label="Navigazione principale"><a href="#recapiti" className="nav-contact" data-testid="header-contacts-link">Contatti</a><a href="#contatto" className="nav-talk" data-testid="header-form-link">Parliamone<ArrowUpRight size={16} /></a></nav>
      </header>
      <main>
        <Hero />
        <QuickContacts />
        <About />
        <BrandMarquee />
        <ContactForm />
      </main>
      <footer className="site-footer page-width" data-testid="site-footer">
        <Brand footer />
        <div className="footer-details"><span data-testid="footer-company">Composite Research</span><a href="mailto:e.fossat@composite-research.com" data-testid="footer-email-link">e.fossat@composite-research.com</a><a href="tel:+393897949730" data-testid="footer-phone-link">389 794 9730</a></div>
        <a className="back-top" href="#inizio" aria-label="Torna all’inizio" data-testid="back-to-top-link"><ArrowUp size={20} /></a>
      </footer>
      <Toaster position="bottom-center" richColors />
    </MotionConfig>
  );
}